/**
 * ^(?![_,\s].+$) negative look ahead for underscore and any whitespace character at the start of the string
 * (?!.*`.*)      negative look ahead for backticks anywhere in the string
 * (?!.*\s$)      negative look ahead for any whitespace character at the end of the string
 */
export const NAME_REGEXP = /^(?![_,\s].*$)(?!.*`.*).*$/;
export const LONG_TEXT_REGEXP = /^(?![_,\s].*$)(?!.*`.*)(?!.*\s$)\n*.*/mu;
